import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Note: stale-chunk recovery (vite:preloadError + a render-error boundary) lives
// in App.tsx with a single timestamp-guarded reload.

createRoot(document.getElementById("root")!).render(<App />);
